var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 2.8125H9.9375V5.0625H13.2861C13.7876 5.0625 14.256 5.31315 14.5342 5.73045L16.3125 8.39792V13.3125H1.6875V2.8125ZM9.9375 6.5625V11.8125H14.8125V8.85208L13.2861 6.5625H9.9375ZM8.4375 11.8125V4.3125H3.1875V11.8125H8.4375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.775 12.75C14.775 14.0962 13.6837 15.1875 12.3375 15.1875C10.9913 15.1875 9.89996 14.0962 9.89996 12.75C9.89996 11.4038 10.9913 10.3125 12.3375 10.3125C13.6837 10.3125 14.775 11.4038 14.775 12.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3375 13.6875C12.8552 13.6875 13.275 13.2678 13.275 12.75C13.275 12.2322 12.8552 11.8125 12.3375 11.8125C11.8197 11.8125 11.4 12.2322 11.4 12.75C11.4 13.2678 11.8197 13.6875 12.3375 13.6875ZM12.3375 15.1875C13.6837 15.1875 14.775 14.0962 14.775 12.75C14.775 11.4038 13.6837 10.3125 12.3375 10.3125C10.9913 10.3125 9.89996 11.4038 9.89996 12.75C9.89996 14.0962 10.9913 15.1875 12.3375 15.1875Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02496 12.75C8.02496 14.0962 6.93366 15.1875 5.58746 15.1875C4.24127 15.1875 3.14996 14.0962 3.14996 12.75C3.14996 11.4038 4.24127 10.3125 5.58746 10.3125C6.93366 10.3125 8.02496 11.4038 8.02496 12.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58746 13.6875C6.10523 13.6875 6.52496 13.2678 6.52496 12.75C6.52496 12.2322 6.10523 11.8125 5.58746 11.8125C5.0697 11.8125 4.64996 12.2322 4.64996 12.75C4.64996 13.2678 5.0697 13.6875 5.58746 13.6875ZM5.58746 15.1875C6.93366 15.1875 8.02496 14.0962 8.02496 12.75C8.02496 11.4038 6.93366 10.3125 5.58746 10.3125C4.24127 10.3125 3.14996 11.4038 3.14996 12.75C3.14996 14.0962 4.24127 15.1875 5.58746 15.1875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.fc1459665cf0b6345f9910e9e5c930f2.svg";
export { ForwardRef as ReactComponent };